export default "__VITE_ASSET__LgPRTItw__"